/* eslint-disable no-unused-vars */
import React from 'react';
import styles from './joincampfire.module.css';
import Organization from './Organization';
import { useDispatch } from 'react-redux';
import { setOrganization } from '../../store/ducks/AuthDuck';
import { useOrganizations } from '../../hooks/api/useOrganization';
// import Header from '../layout/Header';
import { request } from '../../config/axios-utils';
import { useNavigate } from 'react-router-dom';
import Navbar from '../layouts/layoutMain/Navbar';

const JoinCampfirePage = () => {
    const dispatch = useDispatch();
    const { data, status } = useOrganizations();
    const navigation = useNavigate();

    console.log('Enrinque', data);
    const handleSubmit = async org => {
        try {
            const res = await request({
                url: `/users/current-organization/${org.id}`,
                method: 'post'
            });
            console.log('res', res);
            dispatch(
                setOrganization({
                    organization: org.name,
                    idOrganization: org.id,
                    logoOrganization: org.logoPicture
                })
            );
            navigation('/welcome');
        } catch (error) {
            console.log('JoinCampfire', error);
        }
    };

    if (status === 'error') {
        return <h1>An error occurred</h1>;
    }

    return (
        <>
            {/* <Header /> */}
            <Navbar />
            <div className="loginLayout__container">
                <div className={styles.join__container}>
                    <div className={styles.title}>
                        <p>Join a Campfire</p>
                    </div>
                    <ul className={styles.list}>
                        {data &&
                            data.map(org => (
                                <Organization
                                    key={org.id}
                                    org={org}
                                    handleSubmit={handleSubmit}
                                />
                            ))}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default JoinCampfirePage;
